import { jsxs, jsx } from 'react/jsx-runtime';
import { LegacyButton } from '../../navigation/LegacyButton/Button.es.js';
import { ZapCardSteps } from './ZapCardSteps.es.js';

const root = "_root_1ai67_1";
const description = "_description_1ai67_12";
const actions = "_actions_1ai67_21";
const styles = {
	root: root,
	description: description,
	actions: actions
};

const ZapCardDetails = (props) => {
  const target = props.detailsHrefTarget || "_self";
  const editorTarget = props.editorHrefTarget || "_self";
  return jsxs("div", { className: styles.root, "data-zds": true, children: [jsx(ZapCardSteps, { steps: props.steps }), props.children && jsx("div", { className: styles.description, "data-zds": true, children: props.children }), jsx("div", { children: jsxs("div", { className: styles.actions, "data-zds": true, children: [props.detailsHref && jsx(LegacyButton, { color: "secondary", href: props.detailsHref, size: "small", target, children: "See Zap details" }), props.editorHref && jsx(LegacyButton, { color: "primary", hasShadow: true, href: props.editorHref, size: "small", target: editorTarget, children: "Try it" })] }) })] });
};

export { ZapCardDetails };
//# sourceMappingURL=ZapCardDetails.es.js.map
